/**
 * Returns true if the value is a valid S3 URI (s3://bucket/key).
 */
export const isS3Link = (value: string): boolean => {
  return /^s3:\/\/[^/]+\/.+$/.test(value);
};

/**
 * Strips the bucket prefix from an S3 URI and returns the object key.
 * Returns the original value unchanged if it is not a valid S3 URI.
 *
 * @example
 * extractS3Key("s3://my-bucket/path/to/file.txt") // → "path/to/file.txt"
 * extractS3Key("not-a-uri")                        // → "not-a-uri"
 */
export const extractS3Key = (value: string): string => {
  const match = value.match(/^s3:\/\/[^/]+\/(.+)$/);
  return match ? match[1] : value;
};
